var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item["vueRouting"]
    ? _c(
        "router-link",
        {
          class: _vm.classItem(_vm.item),
          attrs: {
            to: _vm.item["url"],
            "data-bot": _vm.item["databot"],
            "data-upsell": _vm.item["data-upsell"]
          }
        },
        [_c("menu-link-item", { attrs: { item: _vm.item } })],
        1
      )
    : !_vm.item["call"] && !_vm.item["sub"]
    ? _c(
        "a",
        {
          class: _vm.classItem(_vm.item),
          attrs: {
            href: _vm.item["url"],
            "data-bot": _vm.item["databot"],
            "data-upsell": _vm.item["data-upsell"],
            target: _vm.item["isExternal"] ? "_blank" : ""
          }
        },
        [_c("menu-link-item", { attrs: { item: _vm.item } })],
        1
      )
    : _c(
        "a",
        {
          class: _vm.classItem(_vm.item),
          attrs: {
            href: "javascript:;",
            onclick: _vm.item["call"],
            "data-bot": _vm.item["databot"],
            "data-upsell": _vm.item["data-upsell"]
          }
        },
        [_c("menu-link-item", { attrs: { item: _vm.item } })],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }